import { useContext } from 'react'
import { PassContext } from "../../../pass-context"
import dataSelector from '../../data-selector'
import PopupEditor from '../../popup-editor'

import { useState } from "react"
import BwipJs from "@bwip-js/browser"

const Barcode = () => {
  const { classData, objectData, variables } = useContext(PassContext)
  const barcodeData = dataSelector({ objectData, variables, path: "barcode" })

  const [img, setImg] = useState(null)
  const [barcodeValue, setBarcodeValue] = useState(null)
  const [barcodeType, setBarcodeType] = useState(null)

  if (barcodeData && barcodeData.value?.length && barcodeData.value !== "NONE") {
    if (!img || barcodeValue !== barcodeData?.value || barcodeType !== barcodeData?.type) {
      const canvas = document.createElement('canvas')

      const barcodeOptions = options[barcodeData?.type]

      if (barcodeOptions) {
        BwipJs.toCanvas(canvas, { ...barcodeOptions, text: barcodeData?.value ?? "dummy barcode payload" })

        let barcode = canvas.toDataURL('image/png')

        setImg(barcode)
        setBarcodeType(barcodeData?.type)
        setBarcodeValue(barcodeData?.value)
      }
    }
  } else {
    if (img) {
      setImg(null)
      setBarcodeType(null)
      setBarcodeValue(null)
    }
  }

  let securityAnimationClass

  if (classData.securityAnimation?.animationType && barcodeData.type !== "NONE") {
    // Show security animation shimmer
    securityAnimationClass = "googleBarcodeSecurityAnimation"
  }

  return (
    <div className="flex flex-row w-full p-3 justify-center" >
      <PopupEditor title="Barcode" type="barcode">
        <div className="barcode editable" style={{ minWidth: 150, minHeight: 20, padding: 2 }}>
          {barcodeData && barcodeData.type !== "NONE" &&
            <div className={securityAnimationClass}>
              <div className={`bg-white text-black ${barcodeShapes[barcodeData?.type]}`}>
                <img src={img} className='w-fit h-fit' />
              </div>
              <div className="text text-center w-full">{barcodeData?.alternateText}</div>
            </div>
          }
        </div>
      </PopupEditor>
    </div>
  )
}

export default Barcode

const barcodeShapes = {
  AZTEC: "square",
  QR_CODE: "square",
  PDF_417: "linear",
  CODE_128: "linear",
}

const options = {
  AZTEC: {
    bcid: 'azteccode',
    scale: 1,
    includetext: false,
    eclevel: 23,
    ecaddchars: 3,
    layers: 8,
    width: 60,
    height: 60,
  },
  QR_CODE: {
    bcid: 'qrcode',
    scale: 1,
    includetext: false,
    eclevel: "M",
    ecaddchars: 3,
    layers: 8,
    width: 60,
    height: 60,
  },
  PDF_417: {
    bcid: 'pdf417',
    scale: 1,
    includetext: false,
    width: 250,
    height: 90,
  },
  CODE_128: {
    bcid: 'code128',
    scale: 1,
    width: 240,
    height: 90,
    includetext: false
  }
}